export const MARKETS_DA = {
    match_odds_ft: "Kampodds (fuld tid)",
    match_odds_ht: "Kampodds (halvleg)",
    goals_ft: "Over/Under {{line}} mål (fuld tid)",
    goals_ht: "Over/Under {{line}} mål (halvleg)",
    player_scores: "{{player}} scorer (fuld tid)",
    corners_ft: "Hjørnespark over/under {{line}} (fuld tid)",
    cards_ft: "Kort over/under {{line}} (fuld tid)",
    draw: "Uafgjort",
    over: "Over {{line}}",
    under: "Under {{line}}",
    yes: "Ja",
    no: "Nej",
}
